// extracted by mini-css-extract-plugin
export default {"navList":"NavList_navList__Mia1s","active":"NavList_active__EE4Ls"};